class InterestingFacts extends Component {
    constructor(el) {
        super(el);
        this.items = [];
        this.duration = 1600;

        const numbers = this.$findAll('.InterestingFacts-number');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (!numbers.length || reducedMotion || typeof IntersectionObserver !== 'function') {
            return;
        }

        numbers.forEach(number => this.prepareItem(number));

        if (this.items.length) {
            this.observe();
        }
    }

    // z textu typu "1 500 +" vytahne cislo a zapamatuje si, jak bylo zapsane
    prepareItem(el) {
        const match = el.textContent.match(/\d[\d\s ]*(?:[.,]\d+)?/);

        if (!match) {
            return;
        }

        const raw = match[0];
        const value = parseFloat(raw.replace(/[\s ]/g, '').replace(',', '.'));

        if (!isFinite(value)) {
            return;
        }

        const decimals = raw.match(/[.,](\d+)$/);
        const separator = raw.match(/\d([\s ])\d/);

        const item = {
            el: el,
            value: value,
            prefix: el.textContent.slice(0, match.index),
            suffix: el.textContent.slice(match.index + raw.length),
            decimals: decimals ? decimals[1].length : 0,
            decimalPoint: raw.includes(',') ? ',' : '.',
            separator: separator ? separator[1] : '',
        };

        this.items.push(item);
        this.renderItem(item, 0);
    }

    // animace se spusti az kdyz je sekce videt, a jen jednou
    observe() {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) {
                    return;
                }

                observer.disconnect();
                this.start();
            });
        }, {threshold: .35});

        observer.observe(this.$el);
    }

    start() {
        const startTime = performance.now();

        const step = (now) => {
            const progress = Math.min((now - startTime) / this.duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);

            this.items.forEach(item => this.renderItem(item, item.value * eased));

            if (progress < 1) {
                requestAnimationFrame(step);
            }
        };

        requestAnimationFrame(step);
    }

    renderItem(item, value) {
        item.el.textContent = item.prefix + this.formatNumber(value, item) + item.suffix;
    }

    formatNumber(value, item) {
        const parts = value.toFixed(item.decimals).split('.');

        if (item.separator) {
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, item.separator);
        }

        return parts.join(item.decimalPoint);
    }
}
